import * as API from "./base";

export const index = (type, params) =>
  API.get("/api/relevance/suggested_" + type, params);

export const friends = (params) => index("friends", params);

export const projects = (params) => index("projects", params);
